// extracted by mini-css-extract-plugin
module.exports = {"Sign_In_Form_Wrap":"SignIn_Sign_In_Form_Wrap__3fU77","Remember_Forgot_Wrap":"SignIn_Remember_Forgot_Wrap__35qTG","Sign_In_Form_Header":"SignIn_Sign_In_Form_Header__3r97O"};